import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';
import { AppUiCustomizationService } from '@shared/common/ui/app-ui-customization.service';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { LocalStorageService } from '@shared/utils/local-storage.service';
@Component({
  templateUrl: './default-brand.component.html',
  selector: 'default-brand',
  encapsulation: ViewEncapsulation.None,
})
export class DefaultBrandComponent extends AppComponentBase {
  defaultLogo =
    AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-light.svg';
  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
  isCollapse = true;

  constructor(
    injector: Injector,
    @Inject(DOCUMENT) private document: Document,
    private _theme: AppUiCustomizationService,
    private _sessionService: AppSessionService,
    private _localStorageService: LocalStorageService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    (async () => {
        var isCollapseVal = await this._localStorageService.getItemAsync(`lhs-is-collapsed-${this._sessionService.user.id}`)
        if(!isCollapseVal) {
            this.isCollapse = false;
            this.toggleLeftAside()
        }
    })();
  }

  toggleLeftAside(): void {

    this._theme._theme.baseSettings.menu.defaultMinimizedAside =
      !this._theme._theme.baseSettings.menu.defaultMinimizedAside;
      this.isCollapse = this._theme._theme.baseSettings.menu.defaultMinimizedAside;
    const collapse = `lhs-is-collapsed-${this._sessionService.user.id}`;
    this._localStorageService.setItemAsync(collapse, this._theme._theme.baseSettings.menu.defaultMinimizedAside);
    this.document.body.classList.toggle('aside-minimize');
    this.triggerAsideToggleClickEvent();
  }

  triggerAsideToggleClickEvent(): void {
    abp.event.trigger('app.kt_aside_toggler.onClick');
  }
}
